export default __webpack_public_path__ + "static/media/noe-display-bold.219885d8.otf";